const Privacy = () => {
  const sections = [
    {
      title: "1. Allgemeine Hinweise",
      content: "Der Schutz deiner persönlichen Daten ist uns ein besonderes Anliegen. Diese Datenschutzerklärung informiert dich über die Art, den Umfang und den Zweck der Verarbeitung personenbezogener Daten durch Angel & Devil Agency LLC gemäß den geltenden Datenschutzgesetzen, insbesondere der Datenschutz-Grundverordnung (DSGVO)."
    },
    {
      title: "2. Verantwortliche Stelle",
      content: (
        <div className="space-y-2">
          <p>Die verantwortliche Stelle für die Datenverarbeitung ist:</p>
          <div className="pl-4 space-y-1">
            <p>Angel & Devil Agency LLC</p>
            <p>7901 4th St N</p>
            <p>St. Petersburg, FL 33702</p>
            <p>USA</p>
            <p>
              📧 E-Mail:{" "}
              <a href="mailto:info@angel-devil.network" className="text-hot-pink hover:text-accent-purple transition-colors">
                info@angel-devil.network
              </a>
            </p>
            <p>
              📞 Telefon:{" "}
              <a href="tel:+13057776989" className="text-hot-pink hover:text-accent-purple transition-colors">
                +1 305 777 6989
              </a>
            </p>
          </div>
        </div>
      )
    },
    {
      title: "3. Daten, die wir erfassen",
      content: (
        <ul className="list-disc pl-6 space-y-2">
          <li>Persönliche Informationen: Name, E-Mail-Adresse, Telefonnummer, Adresse.</li>
          <li>Technische Daten: IP-Adresse, Browser-Typ, Betriebssystem, Zugriffszeiten.</li>
          <li>Plattform- und Nutzungsdaten: Informationen zur Nutzung unserer Website oder Plattformen.</li>
        </ul>
      )
    },
    {
      title: "4. Zweck der Datenverarbeitung",
      content: (
        <div className="space-y-2">
          <p>Wir verarbeiten deine Daten zu folgenden Zwecken:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Zur Bereitstellung unserer Dienstleistungen und Angebote.</li>
            <li>Zur Kommunikation mit dir (z. B. für Anfragen oder Bewerbungen).</li>
            <li>Zur Optimierung und Weiterentwicklung unserer Website.</li>
            <li>Zur Einhaltung gesetzlicher Verpflichtungen.</li>
          </ul>
        </div>
      )
    },
    {
      title: "5. Weitergabe deiner Daten",
      content: (
        <div className="space-y-2">
          <p>Deine Daten werden nur weitergegeben, wenn:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Dies für die Vertragserfüllung erforderlich ist (z. B. bei Versanddiensten).</li>
            <li>Du ausdrücklich eingewilligt hast.</li>
            <li>Wir gesetzlich dazu verpflichtet sind.</li>
          </ul>
        </div>
      )
    },
    {
      title: "6. Speicherung und Löschung von Daten",
      content: (
        <div className="space-y-2">
          <p>Wir speichern deine Daten nur so lange, wie es für die Erfüllung der genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.</p>
          <p>Nach Ablauf der Frist werden deine Daten gelöscht oder anonymisiert.</p>
        </div>
      )
    },
    {
      title: "7. Deine Rechte",
      content: (
        <div className="space-y-2">
          <p>Du hast folgende Rechte hinsichtlich deiner Daten:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Recht auf Auskunft: Erhalte eine Übersicht über die Daten, die wir über dich gespeichert haben.</li>
            <li>Recht auf Berichtigung: Lasse unrichtige Daten korrigieren.</li>
            <li>Recht auf Löschung: Fordere die Löschung deiner Daten an.</li>
            <li>Recht auf Datenübertragbarkeit: Erhalte deine Daten in einem gängigen Format.</li>
            <li>Recht auf Widerspruch: Widerspreche der Verarbeitung deiner Daten aus bestimmten Gründen.</li>
          </ul>
          <p>
            Kontaktiere uns dazu unter:{" "}
            <a href="mailto:info@angel-devil.network" className="text-hot-pink hover:text-accent-purple transition-colors">
              info@angel-devil.network
            </a>
          </p>
        </div>
      )
    },
    {
      title: "8. Sicherheit deiner Daten",
      content: "Wir setzen technische und organisatorische Maßnahmen ein, um deine Daten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen."
    },
    {
      title: "9. Cookies und Tracking-Technologien",
      content: "Wir verwenden Cookies, um die Nutzung unserer Website zu analysieren und zu verbessern. Du kannst die Verwendung von Cookies über deine Browser-Einstellungen steuern."
    },
    {
      title: "10. Änderungen der Datenschutzerklärung",
      content: "Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren, um sie an geänderte rechtliche Anforderungen oder neue Dienstleistungen anzupassen. Die aktuelle Version findest du immer auf unserer Website."
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden w-full">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Datenschutzerklärung – <span className="text-gradient">Angel & Devil Network</span>
            </h1>
            <div className="space-y-2 text-white/80">
              <p>Angel & Devil Agency LLC</p>
              <p>7901 4th St N, St. Petersburg, FL 33702, USA</p>
              <p>
                📧 E-Mail:{" "}
                <a href="mailto:info@angel-devil.network" className="text-hot-pink hover:text-accent-purple transition-colors">
                  info@angel-devil.network
                </a>
              </p>
              <p>
                📞 Telefon:{" "}
                <a href="tel:+13057776989" className="text-hot-pink hover:text-accent-purple transition-colors">
                  +1 305 777 6989
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-20">
        <div className="w-full">
          <div className="space-y-20">
            {sections.map((section, index) => (
              <div key={index} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                <div className="relative w-full">
                  <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                  <div className="relative glass-effect rounded-2xl p-8">
                    <div className="flex items-start gap-6">
                      <div className="shrink-0">
                        <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-hot-pink to-accent-purple flex items-center justify-center">
                          <span className="text-white text-xl">{index + 1}</span>
                        </div>
                      </div>
                      <div>
                        <h2 className="text-2xl font-playfair text-gradient mb-4">{section.title}</h2>
                        <div className="text-white/80 space-y-4">{section.content}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="w-full mt-20 text-center">
          <p className="text-white/80">
            Angel & Devil Network – Where{" "}
            <span className="text-hot-pink">Temptation</span> Meets{" "}
            <span className="text-accent-purple">Talent</span>.
          </p>
          <p className="text-white/80 mt-4">
            Hast du Fragen zum Datenschutz? Kontaktiere uns unter{" "}
            <a href="mailto:info@angel-devil.network" className="text-hot-pink hover:text-accent-purple transition-colors">
              info@angel-devil.network
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
